import * as api from './api';
import { Profitability } from './models';
import * as MutationTypes from './mutationTypes';

export const priceProfitabilityRequest = async ({ commit }, { periodGuid, priceChangesList = [] }) => {
  commit(MutationTypes.IS_PRICE_PROFITABILITY_LOADING_TOGGLE);
  const response = await api.priceProfitabilityRequest(periodGuid, priceChangesList.map((change) => change.serialize()));
  const priceProfitability = new Profitability({ ...response.data, valid: true });
  commit(MutationTypes.PRICE_PROFITABILITY_SUCCESS, priceProfitability);
  commit(MutationTypes.IS_PRICE_PROFITABILITY_LOADING_TOGGLE);
};

export const resetMenuEngineeringProfitability = async ({ commit }) => {
  commit(MutationTypes.RESET_MENU_ENGINEERING_PROFITABILITY);
};

export const predictionPeriodStateRequest = async (context, { periodGuid, stateType }) => {
  const response = await api.periodStateRequest(periodGuid, stateType);
  return response.data;
};

export const boostedProductListRequest = async ({
  commit,
  getters: {
    boostedProductSet,
    boostedMenuProductSet
  }
}, { periodGuid }) => {
  if (boostedProductSet.size === 0 || boostedMenuProductSet.size === 0) {
    const response = await api.boostedProductsRequest(periodGuid);
    const productList = new Set(response.data.boosted_products);
    const menuProductList = new Set(response.data.boosted_menu_products);
    commit(MutationTypes.BOOSTED_PRODUCT_SET_SUCCESS, productList);
    commit(MutationTypes.BOOSTED_MENU_PRODUCT_SET_SUCCESS, menuProductList);
  }
};
